import WorkgroupOrders from "../views/workgroup/WorkgroupOrders.vue";
import WorkgroupOrderCreate from "../views/workgroup/WorkgroupOrderCreate.vue";
import WorkgroupOrderDetail from "../views/workgroup/WorkgroupOrderDetail.vue";
import WorkgroupComments from '../views/workgroup/WorkgroupComments.vue'

const workgroups = [
  {
    path: "/inventory/workgroup/orders",
    name: "workgroup_order",
    component: WorkgroupOrders,
  },
  {
    path: "/inventory/workgroup/orders/detail",
    name: "workgroup_order_detail",
    component: WorkgroupOrderDetail,
  },
  {
    path: "/inventory/workgroup/orders/:target",
    name: "workgroup_order_create",
    component: WorkgroupOrderCreate,
  },
  {
    path: '/workgroup/workgroup_comments',
    name: 'workgroup_comments',
    component: WorkgroupComments
  }
];
// function lazyLoad(view) {
//   return () => import(`@/views/workgroup/${view}.vue`)
// }
// const workgroups = [
//   {
//     path: "/inventory/workgroup/orders",
//     name: "workgroup_order",
//     component:  lazyLoad('WorkgroupOrders'),
//   },
//   {
//     path: "/inventory/workgroup/orders/detail",
//     name: "workgroup_order_detail",
//     component: lazyLoad('WorkgroupOrderDetail'),
//   },
//   {
//     path: "/inventory/workgroup/orders/:target",
//     name: "workgroup_order_create",
//     component: lazyLoad('WorkgroupOrderCreate'),
//   },
//   {
//     path: '/workgroup/workgroup_comments',
//     name: 'workgroup_comments',
//     component: lazyLoad('WorkgroupComments')
//   }
// ];
export default {
  workgroups,
};
